import Ethnicity from "./Ethnicity";
export { Ethnicity };
